export default function LoaderBanner({ text = 'Signing you in…' }) {
  return (
    <div className="fixed top-0 inset-x-0 z-40">
      <div className="mx-auto max-w-6xl px-3">
        <div className="mt-3 rounded-xl bg-sand shadow-md border border-black/5">
          <div className="px-4 py-3 flex items-center gap-3">
            <div className="h-3 w-3 rounded-full animate-pulse bg-brick" />
            <p className="text-cocoa/90">{text}</p>
          </div>
        </div>
      </div>
    </div>
  )
}
